/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Meeting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: bjorn.naeslund@r2m.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableResponse
 */
export interface AvailableResponse {
    /**
     * true if user is available otherwise false
     * @type {boolean}
     * @memberof AvailableResponse
     */
    isAvailable: boolean;
}

export function AvailableResponseFromJSON(json: any): AvailableResponse {
    return AvailableResponseFromJSONTyped(json, false);
}

export function AvailableResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'isAvailable': json['isAvailable'],
    };
}

export function AvailableResponseToJSON(value?: AvailableResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'isAvailable': value.isAvailable,
    };
}


